import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
  forwardRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { TransactionService } from "../../services/transaction.service";
import { ConstantService } from "../../constant/constant-service";
import { TranslateService } from "@ngx-translate/core";

export const AV_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvSpotRegionComponent),
  multi: true,
};

@Component({
  selector: "av-spot-region",
  templateUrl: "./av-spot-region.component.html",
  styleUrls: ["./av-spot-region.component.css"],
  providers: [AV_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class AvSpotRegionComponent implements OnInit {
  @Input() label: string;
  @Input() selectedLabel: string;
  @Input() options: Array<{ label: string; value: any }>;
  @Input() disabled = false;
  @Input() filter = false;
  @Input() variableName: string;

  @Output() sendVariableName: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("input") inputRef: ElementRef;

  selectedAnswer: any;

  constructor(private zone: NgZone,private translateService: TranslateService) {
        //logica
  }

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.options = new Array();
    this.options.push({ label: this.selectedLabel, value: undefined });
    this.options.push({
      label: this.translateService.instant(
        "module.spot.tacticalSpot.regionSouthBound"
      ),
      value: "South bound",
    });
    this.options.push({
      label: this.translateService.instant(
        "module.spot.tacticalSpot.regionNorthBound"
      ),
      value: "North bound",
    });
  }

  propagateChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectedAnswer = value;
  }
  onChange(): void {
    this.zone.run(() => {
      this.propagateChange(this.selectedAnswer);
      this.sendVariableName.emit(this.variableName);
    });
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
